import { Controller } from "@hotwired/stimulus"

// Toast de notification : il apparaît sans animation et disparaît en fondu.
// `transition-opacity` est posé par le composant ; ce contrôleur ajoute `opacity-0` puis
// retire l'élément du DOM une fois la transition écoulée.
export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: true },
    dismissAfter: { type: Number, default: 6000 }
  }

  connect() {
    if (this.autoDismissValue) {
      this.timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue)
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    if (this.timeout) clearTimeout(this.timeout)
    this.element.classList.add("opacity-0")
    setTimeout(() => this.element.remove(), 200)
  }
}
